export const sections = [
  {
    name: "",
    description: "",
    orbit: {
      target: { x: -23.1, y: 2.8, z: 5 },
      camera: { x:11.3, y:34.3, z: -10.3 }
    }
  },
  {
    name: "Helios Terrace",
    description: "A serene escape—sink into plush seating surrounded by timeless Greek elegance.",
    orbit: {
      target: { x:-52.4, y: 0.8, z: -25.6 },
      camera: { x: -7.1, y: 2.4, z:-5.7}
    }
  },

  {
    name: "DEFAULT",
    description: "Main Lounge Area",
    orbit: {
      target: { x:0, y: 3.3, z:0 },
      camera: { x:7.5, y: 2.5, z: 0. }
    }
  },
  {
    name: "Neró Bar",
    description: "A sun-drenched escape where refreshing cocktails and Mediterranean flavors flow as effortlessly as the shimmering waters beside you.",
    orbit: {
      target: { x: -24.4, y: 1.8, z: 3.6 },
      camera: { x: -20.2, y: 1.5, z: -2.6 }
    }
  },
  {
    name: "Ilios Terrace",
    description: " Dine with a breathtaking  view- enjoy a panorama of the Aegean while indulging in elevated flavors.",
    orbit: {
      target: { x: -23.4, y: 4.8, z: 8.4 },
      camera: { x: -14.1, y: 8.4, z: 3.3 }
    }
  },

 
  {
    name: "Kyma Restaurant",
    description: "Savor the flavors of the Mediterranean with fresh, locally sourced cuisine served in an elegant Grecian setting.",
    orbit: {
      target: { x: -10.4, y: 1.8, z: 7.7 },
      camera: { x: -1.4, y:2.2, z: 0.4 }
    }
  },

  {
    name: "Zephyr Bar",
    description: "Cool off with handcrafted cocktails by the infinity pool, where the sea and sky become one.",
    orbit: {
      target: { x: -12.3, y: 2.8, z: 18.7 },
      camera: { x: 0.6, y: 1.3, z: 15.3 }
    }
  },

]; 